import { billOfMaterialsIdFormat } from "@redotech/redo-fulfillment-id";
import * as z from "zod";
import {
  BillOfMaterialsProductInput,
  billOfMaterialsStatusSchema,
} from "./bill-of-materials-types";

const CreateBillOfMaterialsInput_ = z.object({
  name: z.string(),
  tags: z.array(z.string()).optional(),
  status: billOfMaterialsStatusSchema.optional(),
  products: z.array(BillOfMaterialsProductInput).optional(),
});
export const CreateBillOfMaterialsInput: z.ZodType<CreateBillOfMaterialsInput> =
  CreateBillOfMaterialsInput_;
export interface CreateBillOfMaterialsInput extends z.infer<
  typeof CreateBillOfMaterialsInput_
> {}

export const createBillOfMaterials = {
  name: "createBillOfMaterials" as const,
  input: CreateBillOfMaterialsInput,
  output: z.object({ billOfMaterialsId: billOfMaterialsIdFormat.schema }),
};
